import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';

class BinIssueStateConfirmNotWorkOrder extends BinIssueStateMixin(LitEntity) {
  static get styles() {
    return [...super.styles, css`
      h2 {
        margin: 2em;
      }
    `];
  }

  render() {
    return html`
      <h2>There is already an open work order for the device on this bin, would you like to continue?</h2>
      ${this.renderCancelYes()}
    `;
  }
}

window.customElements.define('bin-issue-state-confirm-not-work-order', BinIssueStateConfirmNotWorkOrder);
